// GENERATED by scripts/capture-describe-fixtures.mjs from POST /info {"type":"outcomeTemplates"} on 2026-10-17.
// Do not edit by hand. The live list (useOutcomeTemplates) is merged over this snapshot at runtime.
import type { TemplateSnapshot } from './templates';

export const TEMPLATE_SNAPSHOT: TemplateSnapshot = {
 "common": {
  "awardCandidate": {
   "name": "{candidate}",
   "role": "questionOutcome",
   "parent": "awardWinner",
   "keywords": {
    "candidate": "string",
    "subject": "string"
   }
  },
  "awardEntryWins": {
   "name": "{displayName} wins {period} {award}?",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "award": "string",
    "awardingBody": "string",
    "displayName": "string",
    "entry": "string",
    "field": "string",
    "period": "string",
    "resolutionDeadline": "dateTime"
   },
   "category": "culture"
  },
  "awardOther": {
   "name": "Other",
   "role": "questionOutcome",
   "parent": "awardWinner",
   "keywords": {}
  },
  "awardWinner": {
   "name": "{period} {award} winner",
   "role": "question",
   "keywords": {
    "award": "string",
    "awardingBody": "string",
    "field": "string",
    "period": "string",
    "resolutionDeadline": "dateTime"
   },
   "category": "culture"
  },
  "binaryPriceExternal": {
   "name": "{shortName} above {threshold} on {time}?",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "feed": "string",
    "instrument": "string",
    "priceDescription": "string",
    "seconds": "uInt",
    "shortName": "shortString",
    "threshold": "uDecimal",
    "time": "dateTime"
   },
   "category": "price"
  },
  "companyIpoConfirmed": {
   "name": "{company} IPO confirmed by {dateTime}",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "company": "string",
    "dateTime": "dateTime"
   },
   "category": "economics"
  },
  "companyIpoFirstDayMarketCap": {
   "name": "{company} first-day market cap above ${marketCapThresholdB}B?",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "company": "string",
    "listingDeadline": "dateTime",
    "marketCapThresholdB": "uDecimal"
   },
   "category": "economics"
  },
  "policyRateBucket": {
   "name": "{bucketLabel}",
   "role": "questionOutcome",
   "parent": "policyRateLadder",
   "keywords": {
    "bucketLabel": "string",
    "lowerBps": "string",
    "upperBps": "string"
   }
  },
  "policyRateDecision": {
   "name": "{institution} {decisionLabel} rate decision",
   "role": "question",
   "keywords": {
    "decisionDeadline": "dateTime",
    "decisionLabel": "string",
    "institution": "string",
    "officialSource": "string",
    "policyMeasure": "string",
    "scheduledDecision": "dateTime"
   },
   "category": "economics"
  },
  "policyRateDecrease": {
   "name": "Decrease",
   "role": "questionOutcome",
   "parent": "policyRateDecision",
   "keywords": {}
  },
  "policyRateIncrease": {
   "name": "Increase",
   "role": "questionOutcome",
   "parent": "policyRateDecision",
   "keywords": {}
  },
  "policyRateLadder": {
   "name": "{institution} {decisionLabel} rate decision",
   "role": "question",
   "keywords": {
    "decisionDeadline": "dateTime",
    "decisionLabel": "string",
    "institution": "string",
    "officialSource": "string",
    "policyMeasure": "string",
    "scheduledDecision": "dateTime"
   },
   "category": "economics"
  },
  "policyRateNoChange": {
   "name": "No change",
   "role": "questionOutcome",
   "parent": "policyRateDecision",
   "keywords": {}
  },
  "priceTouch": {
   "name": "{perp} touches {target} by {time}",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "perp": "hlPerp",
    "priceDescription": "string",
    "seconds": "uInt",
    "target": "uDecimal",
    "time": "dateTime"
   },
   "category": "price"
  },
  "sportsOverUnderMarket": {
   "name": "{event}: {measure} over/under {line}",
   "role": "outcome",
   "sideNames": [
    "Over",
    "Under"
   ],
   "keywords": {
    "countedPlay": "string",
    "event": "string",
    "line": "uDecimal",
    "measure": "string",
    "officialSource": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "sport": "string"
   },
   "category": "sports"
  },
  "sportsSpread": {
   "name": "{participantA} v {participantB}: {shortNameA} {spread}",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "countedPlay": "string",
    "measure": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "shortNameA": "shortString",
    "sport": "string",
    "spread": "string"
   },
   "category": "sports"
  },
  "sportsTotal": {
   "name": "{participantA} v {participantB}: total {line}",
   "role": "outcome",
   "sideNames": [
    "Over",
    "Under"
   ],
   "keywords": {
    "countedPlay": "string",
    "line": "uDecimal",
    "measure": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "sport": "string"
   },
   "category": "sports"
  },
  "sportsTournamentParticipant": {
   "name": "{participant}",
   "role": "questionOutcome",
   "parent": "sportsTournamentWinner",
   "keywords": {
    "participant": "string"
   }
  }
 },
 "mainnet": {
  "aiModelHeadToHead": {
   "name": "{shortNameA} v {shortNameB}: {leaderboard} on {dateTime}",
   "role": "outcome",
   "sideNames": [
    "{shortNameA}",
    "{shortNameB}"
   ],
   "keywords": {
    "benchmarkSettings": "string",
    "comparisonDirection": "string",
    "dateTime": "dateTime",
    "leaderboard": "string",
    "leaderboardUrl": "string",
    "metric": "string",
    "modelA": "string",
    "modelB": "string",
    "shortNameA": "shortString",
    "shortNameB": "shortString",
    "tiebreakers": "string"
   },
   "category": "technology"
  },
  "binaryPrice": {
   "name": "{perp} above {threshold} at {time}?",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "perp": "hlPerp",
    "priceDescription": "string",
    "seconds": "uInt",
    "threshold": "uDecimal",
    "time": "dateTime"
   },
   "category": "price"
  },
  "scalarPrice": {
   "name": "{perp} from {low} to {high} at {time}",
   "role": "outcome",
   "sideNames": [
    "Long",
    "Short"
   ],
   "keywords": {
    "high": "uDecimal",
    "low": "uDecimal",
    "perp": "hlPerp",
    "priceDescription": "string",
    "seconds": "uInt",
    "time": "dateTime"
   },
   "category": "price"
  },
  "sportsContestDraw2": {
   "name": "Draw",
   "role": "questionOutcome",
   "parent": "sportsContestResult",
   "keywords": {}
  },
  "sportsContestParticipant2": {
   "name": "{participant}",
   "role": "questionOutcome",
   "parent": "sportsContestResult",
   "keywords": {
    "participant": "string"
   }
  },
  "sportsContestResult": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "question",
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "countedPlay": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestWinner": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "outcome",
   "sideNames": [
    "{shortNameA}",
    "{shortNameB}"
   ],
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "countedPlay": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "shortNameA": "shortString",
    "shortNameB": "shortString",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsScalarMarket": {
   "name": "{event}: {measure} from {low} to {high}",
   "role": "outcome",
   "sideNames": [
    "Over",
    "Under"
   ],
   "keywords": {
    "countedPlay": "string",
    "event": "string",
    "high": "uDecimal",
    "low": "uDecimal",
    "measure": "string",
    "officialSource": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "sport": "string"
   },
   "category": "sports"
  },
  "sportsTournamentNoWinner2": {
   "name": "No winner",
   "role": "questionOutcome",
   "parent": "sportsTournamentWinner",
   "keywords": {}
  },
  "sportsTournamentWinner": {
   "name": "{season} {competition} winner",
   "role": "question",
   "keywords": {
    "competition": "string",
    "officialSource": "string",
    "resolutionDeadline": "dateTime",
    "season": "string",
    "sport": "string"
   },
   "category": "sports"
  }
 },
 "testnet": {
  "aiModelHeadToHead": {
   "name": "{shortNameA} v {shortNameB} on {dateTime}",
   "role": "outcome",
   "sideNames": [
    "{shortNameA}",
    "{shortNameB}"
   ],
   "keywords": {
    "dateTime": "dateTime",
    "modelA": "string",
    "modelB": "string",
    "shortNameA": "shortString",
    "shortNameB": "shortString"
   },
   "category": "technology"
  },
  "binaryPrice": {
   "name": "{perp} above {threshold} at {time}?",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "perp": "hlPerp",
    "threshold": "string",
    "time": "dateTime"
   }
  },
  "binaryPrice2": {
   "name": "{perp} above {threshold} at {time}?",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "perp": "hlPerp",
    "threshold": "uDecimal",
    "time": "dateTime"
   }
  },
  "binaryPrice4": {
   "name": "{perp} above {threshold} at {time}?",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "perp": "hlPerp",
    "priceDescription": "string",
    "seconds": "uInt",
    "threshold": "uDecimal",
    "time": "dateTime"
   }
  },
  "binaryPrice5": {
   "name": "{perp} above {threshold} at {time}?",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "perp": "hlPerp",
    "priceDescription": "string",
    "seconds": "uInt",
    "threshold": "uDecimal",
    "time": "dateTime"
   },
   "category": "price"
  },
  "binaryPrice6": {
   "name": "{perp} above {threshold} at {time}?",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "perp": "hlPerp",
    "priceDescription": "string",
    "seconds": "uInt",
    "threshold": "uDecimal",
    "time": "dateTime"
   },
   "category": "price"
  },
  "policyRateDecision2": {
   "name": "{institution} {decisionLabel} rate decision",
   "role": "question",
   "keywords": {
    "decisionDeadline": "dateTime",
    "decisionLabel": "string",
    "institution": "string",
    "officialSource": "string",
    "policyMeasure": "string",
    "scheduledDecision": "dateTime"
   },
   "category": "economics"
  },
  "policyRateDecision3": {
   "name": "{institution} {decisionLabel} rate decision",
   "role": "question",
   "keywords": {
    "decisionDeadline": "dateTime",
    "decisionLabel": "string",
    "institution": "string",
    "officialSource": "string",
    "policyMeasure": "string",
    "scheduledDecision": "dateTime"
   },
   "category": "economics"
  },
  "policyRateDecrease2": {
   "name": "Decrease",
   "role": "questionOutcome",
   "parent": "policyRateDecision2",
   "keywords": {}
  },
  "policyRateDecrease3": {
   "name": "Decrease",
   "role": "questionOutcome",
   "parent": "policyRateDecision3",
   "keywords": {}
  },
  "policyRateIncrease2": {
   "name": "Increase",
   "role": "questionOutcome",
   "parent": "policyRateDecision2",
   "keywords": {}
  },
  "policyRateIncrease3": {
   "name": "Increase",
   "role": "questionOutcome",
   "parent": "policyRateDecision3",
   "keywords": {}
  },
  "policyRateNoChange2": {
   "name": "No change",
   "role": "questionOutcome",
   "parent": "policyRateDecision2",
   "keywords": {}
  },
  "policyRateNoChange3": {
   "name": "No change",
   "role": "questionOutcome",
   "parent": "policyRateDecision3",
   "keywords": {}
  },
  "priceTouch2": {
   "name": "{perp} touches {target} by {time}",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "perp": "hlPerp",
    "priceDescription": "string",
    "seconds": "uInt",
    "target": "uDecimal",
    "time": "dateTime"
   },
   "category": "price"
  },
  "scalarPrice3": {
   "name": "{perp} from {low} to {high} at {time}",
   "role": "outcome",
   "sideNames": [
    "Long",
    "Short"
   ],
   "keywords": {
    "high": "uDecimal",
    "low": "uDecimal",
    "perp": "hlPerp",
    "priceDescription": "string",
    "seconds": "uInt",
    "time": "dateTime"
   },
   "category": "price"
  },
  "scalePrice": {
   "name": "{perp} from {low} to {high} at {time}",
   "role": "outcome",
   "sideNames": [
    "Long",
    "Short"
   ],
   "keywords": {
    "high": "uDecimal",
    "low": "uDecimal",
    "perp": "hlPerp",
    "priceDescription": "string",
    "seconds": "uInt",
    "time": "dateTime"
   },
   "category": "price"
  },
  "scalePrice2": {
   "name": "{perp} from {low} to {high} at {time}",
   "role": "outcome",
   "sideNames": [
    "Long",
    "Short"
   ],
   "keywords": {
    "high": "uDecimal",
    "low": "uDecimal",
    "perp": "hlPerp",
    "priceDescription": "string",
    "seconds": "uInt",
    "time": "dateTime"
   },
   "category": "price"
  },
  "sportsContestDraw": {
   "name": "Draw",
   "role": "questionOutcome",
   "parent": "sportsContestResult",
   "keywords": {}
  },
  "sportsContestDraw2": {
   "name": "Draw",
   "role": "questionOutcome",
   "parent": "sportsContestResult2",
   "keywords": {}
  },
  "sportsContestDraw3": {
   "name": "Draw",
   "role": "questionOutcome",
   "parent": "sportsContestResult3",
   "keywords": {}
  },
  "sportsContestDraw4": {
   "name": "Draw",
   "role": "questionOutcome",
   "parent": "sportsContestResult4",
   "keywords": {}
  },
  "sportsContestDraw5": {
   "name": "Draw",
   "role": "questionOutcome",
   "parent": "sportsContestResult5",
   "keywords": {}
  },
  "sportsContestParticipant": {
   "name": "{participant}",
   "role": "questionOutcome",
   "parent": "sportsContestResult",
   "keywords": {
    "participant": "string"
   }
  },
  "sportsContestParticipant2": {
   "name": "{participant}",
   "role": "questionOutcome",
   "parent": "sportsContestResult2",
   "keywords": {
    "participant": "string"
   }
  },
  "sportsContestParticipant3": {
   "name": "{participant}",
   "role": "questionOutcome",
   "parent": "sportsContestResult3",
   "keywords": {
    "participant": "string"
   }
  },
  "sportsContestParticipant4": {
   "name": "{participant}",
   "role": "questionOutcome",
   "parent": "sportsContestResult4",
   "keywords": {
    "participant": "string"
   }
  },
  "sportsContestParticipant5": {
   "name": "{participant}",
   "role": "questionOutcome",
   "parent": "sportsContestResult5",
   "keywords": {
    "participant": "string"
   }
  },
  "sportsContestResult": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "question",
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestResult2": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "question",
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestResult3": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "question",
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestResult4": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "question",
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestResult5": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "question",
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestWinner": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "outcome",
   "sideNames": [
    "Yes",
    "No"
   ],
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestWinner2": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "outcome",
   "sideNames": [
    "{shortNameA}",
    "{shortNameB}"
   ],
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestWinner3": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "outcome",
   "sideNames": [
    "{shortNameA}",
    "{shortNameB}"
   ],
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "shortNameA": "shortString",
    "shortNameB": "shortString",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestWinner4": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "outcome",
   "sideNames": [
    "{shortNameA}",
    "{shortNameB}"
   ],
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "shortNameA": "shortString",
    "shortNameB": "shortString",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestWinner5": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "outcome",
   "sideNames": [
    "{shortNameA}",
    "{shortNameB}"
   ],
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "shortNameA": "shortString",
    "shortNameB": "shortString",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestWinner6": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "outcome",
   "sideNames": [
    "{shortNameA}",
    "{shortNameB}"
   ],
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "shortNameA": "shortString",
    "shortNameB": "shortString",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsContestWinner7": {
   "name": "{competition} {stage}: {participantA} v {participantB}",
   "role": "outcome",
   "sideNames": [
    "{shortNameA}",
    "{shortNameB}"
   ],
   "keywords": {
    "competition": "string",
    "contestType": "string",
    "officialSource": "string",
    "participantA": "string",
    "participantB": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "season": "string",
    "shortNameA": "shortString",
    "shortNameB": "shortString",
    "sport": "string",
    "stage": "string"
   },
   "category": "sports"
  },
  "sportsScalarMarket": {
   "name": "{measure} from {low} to {high}",
   "role": "outcome",
   "sideNames": [
    "Over",
    "Under"
   ],
   "keywords": {
    "high": "uDecimal",
    "low": "uDecimal",
    "measure": "string"
   },
   "category": "sports"
  },
  "sportsScalarMarket2": {
   "name": "{measure} from {low} to {high}",
   "role": "outcome",
   "sideNames": [
    "Over",
    "Under"
   ],
   "keywords": {
    "high": "uDecimal",
    "low": "uDecimal",
    "measure": "string"
   },
   "category": "sports"
  },
  "sportsScalarMarket3": {
   "name": "{measure} from {low} to {high}",
   "role": "outcome",
   "sideNames": [
    "Over",
    "Under"
   ],
   "keywords": {
    "event": "string",
    "high": "uDecimal",
    "low": "uDecimal",
    "measure": "string",
    "officialSource": "string",
    "resolutionDeadline": "dateTime",
    "scheduledStart": "dateTime",
    "sport": "string"
   },
   "category": "sports"
  },
  "sportsTournamentParticipant2": {
   "name": "{participant}",
   "role": "questionOutcome",
   "parent": "sportsTournamentWinner2",
   "keywords": {
    "participant": "string"
   }
  },
  "sportsTournamentParticipant3": {
   "name": "{participant}",
   "role": "questionOutcome",
   "parent": "sportsTournamentWinner3",
   "keywords": {
    "participant": "string"
   }
  },
  "sportsTournamentParticipant4": {
   "name": "{participant}",
   "role": "questionOutcome",
   "parent": "sportsTournamentWinner4",
   "keywords": {
    "participant": "string"
   }
  },
  "sportsTournamentWinner": {
   "name": "{season} {competition} Winner",
   "role": "question",
   "keywords": {
    "competition": "string",
    "officialSource": "string",
    "resolutionDeadline": "dateTime",
    "season": "string",
    "sport": "string"
   },
   "category": "sports"
  },
  "sportsTournamentWinner2": {
   "name": "{season} {competition} Winner",
   "role": "question",
   "keywords": {
    "competition": "string",
    "officialSource": "string",
    "resolutionDeadline": "dateTime",
    "season": "string",
    "sport": "string"
   },
   "category": "sports"
  },
  "sportsTournamentWinner3": {
   "name": "{season} {competition} Winner",
   "role": "question",
   "keywords": {
    "competition": "string",
    "officialSource": "string",
    "resolutionDeadline": "dateTime",
    "season": "string",
    "sport": "string"
   },
   "category": "sports"
  },
  "sportsTournamentWinner4": {
   "name": "{season} {competition} Winner",
   "role": "question",
   "keywords": {
    "competition": "string",
    "officialSource": "string",
    "resolutionDeadline": "dateTime",
    "season": "string",
    "sport": "string"
   },
   "category": "sports"
  }
 }
};
